module.exports = __webpack_public_path__ + "static/media/home-heart.bc997605.svg";